








































import { Component, Vue } from 'vue-property-decorator'
import HomeModule from '@api/module/customer/basic-data/BasicDataModule'
import { TeachUnit } from '@api/model/basic-data/TeachUnit'

@Component
export default class extends Vue {
  get currentUnit() {
    return HomeModule.currentUnit || new TeachUnit()
  }

  get isMobileShow() {
    return HomeModule?.currentUnit?.mobileShow || false
  }
  get isWxShow() {
    return HomeModule?.currentUnit?.wxShow || false
  }
  // 是不是忘记密码 忘记密码不要页面脚 src\portal\views\forgot-password\forgot-password.vue
  get isForgotPassword() {
    const name = this.$route.name
    console.log(name)
    if (name === 'ForgotPassword') {
      return true
    }
    return false
  }
}
